import { THREE, DEG2RAD, __DEFAULT_SMOOTH_TIME } from './context.js';

const resetCamera = () => {
  window.camera3.current.reset();
  // window.camera3.current._camera.lookAt(0,1,0)
  // window.camera3.current._camera.rotation.set(0,1,0)
  // window.camera3.current.smoothTime = __DEFAULT_SMOOTH_TIME
}

// Extra fitToBox top padding (world units) so the fitted graph sits below the
// severity-chip header strip instead of colliding with it. Proportional to the
// graph's own height because fitToBox paddings are world units, not pixels.
const TOP_SAFE_FRACTION = 0.12;
function topSafeInset(obj) {
  try {
    const box = new THREE.Box3().setFromObject(obj);
    const h = box.max.y - box.min.y;
    return Number.isFinite(h) ? h * TOP_SAFE_FRACTION : 0;
  } catch (e) {
    return 0;
  }
}

function animateChangeRotation2(inOBJ) {
  setTimeout(() => {
    for (let i = 0; i < window.scene3.children.length; i++) {
      if (window.scene3.children[i].type == "Group") {
        window.forceGraph = window.scene3.children[i]
        let padding = 42;
        let obj = inOBJ || window.forceGraph;
        if(obj?.children?.length == 0){
          return;
        }
        window.camera3.current.fitToBox(obj, true, { paddingTop: padding + topSafeInset(obj), paddingBottom: padding, paddingLeft: padding, paddingRight: padding });
        window.camera3.current?.rotate(
          (parseInt(Math.random() * 4) % 2 == 0 ? 1 : -1) *
          65 * DEG2RAD, -25 * DEG2RAD, true);
        break
      }
    }
  }, 42)
}





function animateChangeRotation(inOBJ, inPadding, noRotate = false) {
  setTimeout(() => {
    if (!window.camera3.current) return;
    window.camera3.current.smoothTime = __DEFAULT_SMOOTH_TIME

    for (let i = 0; i < window.scene3.children.length; i++) {
      if (window.scene3.children[i].type == "Group") {
        window.forceGraph = window.scene3.children[i]
        let padding = inPadding || 64.2;
        let obj = inOBJ || window.forceGraph;
        if(obj?.children?.length == 0){
          return;
        }
        window.camera3.current.fitToBox(obj, true, { paddingTop: padding + topSafeInset(obj), paddingBottom: padding, paddingLeft: padding, paddingRight: padding });
        if (noRotate != true) {
          window.camera3.current?.rotate(
            (parseInt(Math.random() * 4) % 2 == 0 ? 1 : -1) *
            45 * DEG2RAD, -25 * DEG2RAD, true);
        }
        break
      }
    }

  }, 42)
}

// fitToBox on a clicked node parks the orbit target (rotation pivot) on that node;
// this moves the pivot back to the graph's center WITHOUT moving the camera, so the
// view stays where the user left it but rotation stops orbiting a stale point.
function reorbitToGraphCenter() {
  try {
    if (!window.forceGraph) {
      for (let i = 0; i < window.scene3.children.length; i++) {
        if (window.scene3.children[i].type == "Group") {
          window.forceGraph = window.scene3.children[i]
          break
        }
      }
    }
    if (!window.forceGraph || !window.camera3?.current) return;
    const box = new THREE.Box3().setFromObject(window.forceGraph);
    const c = box.getCenter(new THREE.Vector3());
    if ([c.x, c.y, c.z].every(Number.isFinite)) {
      window.camera3.current.setOrbitPoint(c.x, c.y, c.z);
    }
  } catch (e) { }
}

var cameraTarget = new THREE.Group();
cameraTarget.position.set(0, 0, 0)
const padding = 142

export { resetCamera, animateChangeRotation, animateChangeRotation2, reorbitToGraphCenter, cameraTarget, padding };
